/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import React, {useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {useParams} from 'react-router'

import useFetchReportById from '../../../hooks/useFetchReportById'

const ReportsDetailsViewHeader: React.FC = () => {
  const {id} = useParams()
  const {report, error, loading} = useFetchReportById(id)
  const [activate, setActivate] = useState(false)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (report?.status === 'resolved') {
      setActivate(true)
    } else {
      setActivate(false)
    }
  }, [report])

  if (loading) {
    return <> Loading</>
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-9'>
        <div className='d-flex justify-content-center align-items-center flex-column flex-wrap flex-sm-nowrap mb-3'>
          <div className=''>
            <div className='form-check form-switch form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                value={activate}
                id='flexSwitchDefault'
                onClick={() => setShowModal(true)}
                checked={activate}
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_1'
              />
              <label
                htmlFor='flexSwitchDefault'
                style={{fontWeight: 'bold', margin: '4px 8px'}}
                className='btn'
              >
                {activate ? 'Resolved' : 'Pending'}
              </label>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <MessageModal
          id={id}
          activate={activate}
          showModal={showModal}
          setShowModal={setShowModal}
          setActivate={setActivate}
          report={report}
        />
      )}
    </div>
  )
}

const MessageModal = ({showModal, setShowModal, message, activate, setActivate, report}) => {
  const {id} = useParams()

  const [updateReportStatus] = useMutation(UPDATE_REPORT_STATUS)
  const handleStatus = async () => {
    try {
      let status = activate ? 'pending' : 'resolved'
      const response = await updateReportStatus({
        variables: {
          updateReportStatusId: id,
          status: status,
        },
      })
      setActivate((pv) => !pv)
    } catch (error) {
    } finally {
      setShowModal(false)
    }
  }
  return (
    <>
      <>
        <div
          className='modal fade show d-block'
          id='kt_modal_add_user'
          role='dialog'
          tabIndex={-1}
          aria-modal='true'
        >
          <div className='modal-dialog modal-dialog-centered mw-550px'>
            <div className='modal-content'>
              <div className='modal-body scroll-y '>
                <div className='modal-header'>
                  <h5 className='modal-title fs-2'>
                    {' '}
                    {report?.status !== 'resolved' ? 'Pending' : 'Resolved'}
                  </h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={() => setShowModal(false)}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>
                <div className='modal-body fs-3'>
                  <p>
                    {activate
                      ? 'Are you sure you want to mark this report as pending?'
                      : 'Are you sure you want to mark this report as resolved?'}
                  </p>
                </div>
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => setShowModal(false)}
                    data-bs-dismiss='modal'
                  >
                    No
                  </button>
                  <button onClick={handleStatus} type='button' className='btn btn-primary'>
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='modal-backdrop fade show'></div>
      </>
    </>
  )
}

export default ReportsDetailsViewHeader
